import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Bubble, Message, withTheme } from '../../../../common';
import modules from './user.module.scss'
import Header from '../Header';

const User = (props = {}) => {
    const { children, label: labelText, accessibleSenderLabel, darkMode, className, theme, timestamp, ...rest } = props;
    const { userMessage, text } = theme

    const label = <Header 
        label={labelText}
        timestamp={timestamp}
        srOnly={" - Your Message"}
    />

    return <Message color={text} alignment={'right'} className={className} label={label} {...rest}>
        <Bubble color={userMessage.text} backgroundColor={userMessage.background} borderColor={userMessage.border} className={modules.bubble} senderLabel={accessibleSenderLabel}>
            {children}
        </Bubble>
    </Message>
}

User.defaultProps = {
    className: '',
    label: 'me',
    accessibleSenderLabel: 'I say',
    darkMode: false,
    theme: {
        userMessage: {}
    }
};

User.propTypes = {
    label: PropTypes.node,
    className: PropTypes.string,
    accessibleSenderLabel: PropTypes.string,
    darkMode: PropTypes.bool
};

export default withTheme(User);